Ext.define('SA.VectorMapToolButtons', {
    alias: 'widget.vector-map-tool-buttons',
    extend: 'Ext.Component',

    baseCls: 'sa-vector-map-tool-buttons',

    renderTpl: [
        '<button class="sa-vector-map-tool-buttons-button sa-vector-map-tool-buttons-button-selected" data-tool="dragPan" title="Pan"><svg aria-hidden="true" class="sa-vector-map-tool-buttons-svg"><use href="#sa-icon-map-pan"></use></svg></button>',
        '<div class="sa-vector-map-tool-buttons-separator"></div>',
        '<button class="sa-vector-map-tool-buttons-button" data-tool="dragZoom" title="Zoom in with bounding box"><svg aria-hidden="true" class="sa-vector-map-tool-buttons-svg"><use href="#sa-icon-map-zoom"></use></svg></button>',
        '<div class="sa-vector-map-tool-buttons-separator"></div>',
        '<button class="sa-vector-map-tool-buttons-button" data-tool="clickInfo" title="Information"><svg aria-hidden="true" class="sa-vector-map-tool-buttons-svg"><use href="#sa-icon-map-info"></use></svg></button>'
    ],

    getActiveToolType() {
        return new SA.VectorMapToolType(this.el.down('.sa-vector-map-tool-buttons-button-selected', true).getAttribute('data-tool'));
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onButtonClick, this, {delegate: '.sa-vector-map-tool-buttons-button'});
    },

    onButtonClick(ev, el) {
        this.setActiveToolType(new SA.VectorMapToolType(el.getAttribute('data-tool')));

        this.fireEvent('click');
    },

    onClick(callback, scope) {
        this.on('click', callback, scope);
    },

    setActiveToolType(toolType) {
        for (let button of this.el.query('.sa-vector-map-tool-buttons-button')) {
            button.classList.toggle('sa-vector-map-tool-buttons-button-selected', button.getAttribute('data-tool') === toolType.getName());
        }
    }
});
